// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  font-family: sans-serif;
  text-align: center;
}

:where(.css-dev-only-do-not-override-1m62vyb).ant-menu-light.ant-menu-root.ant-menu-inline {
  border-inline-end: 0px solid rgba(5, 5, 5, 0.06);
}

.list-group-item {
  background-color: #23395d !important;
  color: #fff;
}

.card-title {
  text-align: "center";
  background-color: #23395d;
  color: #fff;
}

.page-container {
  padding: 2px;
}

.card-container {
  margin-top: 0px;
}

.card-body {
  padding: 0.5rem;
  border-radius: 0px;
}

.col-sm-6 {
  margin-bottom: 5px;
  width: 100%;
}

.primary-hr {
  background: rgba(35, 57, 93, 0.231372549);
}

.card {
  width: 98% !important;
  height: 100% !important;
  background-color: #23395d !important;
  border-radius: 10px !important;
}

@media (max-width: 623px) {
  .card-header {
    padding: 0.45rem 0.15rem !important;
  }
  .card {
    margin-left: 0px !important;
    border-radius: 10px;
  }
}
@media (max-width: 320) {
  .card {
    margin-left: 0px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/admin/parent/cardview.scss"],"names":[],"mappings":"AAAA;EACE,uBAAA;EACA,kBAAA;AACF;;AACA;EACE,gDAAA;AAEF;;AACA;EACA,oCAAA;EACA,WAAA;AAEA;;AASA;EACE,oBAAA;EACA,yBAAA;EACA,WAAA;AANF;;AASA;EACE,YAAA;AANF;;AAYA;EACE,eAAA;AATF;;AAkBA;EACE,eAAA;EACA,kBAAA;AAfF;;AAkBA;EAEE,kBAAA;EACA,WAAA;AAhBF;;AAoBA;EACE,yCAAA;AAjBF;;AAsBA;EACE,qBAAA;EACA,uBAAA;EACA,oCAAA;EACA,8BAAA;AAnBF;;AAqBA;EAME;IACE,mCAAA;EAvBF;EA0BA;IACE,2BAAA;IACA,mBAAA;EAxBF;AACF;AA2BA;EAEE;IACE,2BAAA;EA1BF;AACF","sourcesContent":[".App {\n  font-family: sans-serif;\n  text-align: center;\n}\n:where(.css-dev-only-do-not-override-1m62vyb).ant-menu-light.ant-menu-root.ant-menu-inline{\n  border-inline-end: 0px solid rgba(5, 5, 5, 0.06);\n}\n\n.list-group-item{\nbackground-color:#23395d !important;\ncolor: #fff;\n}\n\n// .page-header {\n//   display: flex !important;\n//     flex-wrap: wrap !important;\n//     justify-content: flex-end !important;\n//     align-items: flex-start !important;\n\n// }\n\n.card-title{\n  text-align: 'center';\n  background-color:#23395d;\n  color: #fff;\n}\n\n.page-container{\n  padding: 2px;\n  // display: flex;\n  // flex-direction: row;\n  // flex-wrap: wrap;\n}\n\n.card-container{\n  margin-top:0px;\n  // display: flex;\n  // flex-direction: row;\n  // justify-content: space-evenly;\n  // flex-wrap: nowrap;\n  // align-items: flex-start;\n}\n\n\n.card-body{\n  padding:0.5rem;\n  border-radius: 0px;\n}\n\n.col-sm-6{\n  // background-color: #23395d;\n  margin-bottom: 5px;\n  width: 100%;\n}\n\n\n.primary-hr{\n  background:#23395d3b;\n  // margin-top: 0rem !important;\n  // margin-bottom: 0rem !important;\n  // border: 1px solid $primary-color !important;\n}\n.card{\n  width: 98% !important;\n  height: 100% !important;\n  background-color:#23395d !important; \n  border-radius:10px!important; \n}\n@media (max-width: 623px) {\n  // .rowmb{\n  //   // box-sizing: content-box !important;\n  //   height: 200px !important;\n  // }\n  \n  .card-header{\n    padding:0.45rem 0.15rem !important;\n  }\n\n  .card{\n    margin-left:0px !important; \n    border-radius:10px;\n  }\n}\n\n@media (max-width: 320) {\n\n  .card{\n    margin-left:0px !important; \n  }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
